import { storybookReady } from '../../../core/js/utils'
import rovingTabindex from '../../../core/js/rovingTabindex'

let storybook, settings

(async function () {
  storybook = await storybookReady()

  settings = storybook ? {
    debug: true
  } : (window.brandPage || {})

  document.querySelectorAll('.Toolbar').forEach(item => {
    new Toolbar(item)
  })

  window.addEventListener(
    'dialogopened',
    () => {
      /**
       * Form post action
       */
      const endpoint =
        window.contact_form_endpoint ||
        'https://uat.eco.farm.pittimmagine.info/e-pitti/fairs/pittiimmagineuomo96/stands/E/esemplare/esemplare'
      const options = document.getElementById('options')
      const options2 = document.getElementById('options2')
      const notes = document.getElementById('notes')
      const emailFrom = document.getElementById('emailFrom')
      const send = document.getElementById('contact_send_btn')

      function emptyDialog () {
        const e = document.querySelector('.Dialog__Content')
        while (e.firstChild) {
          e.removeChild(e.firstChild)
        }
      }

      let selected, selected2

      options && options.addEventListener('change', () => {
        selected = options[options.selectedIndex].getAttribute('value')
      })

      options2 && options2.addEventListener('change', () => {
        selected2 = options2[options2.selectedIndex].getAttribute('value')
      })

      send && send.addEventListener('click', () => {
        fetch(endpoint, {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: 'contact=true&subject=' + encodeURIComponent(selected) + '&recipient=' + encodeURIComponent(selected2) + '&text=' + encodeURIComponent(notes.value) + '&emailFrom=' + encodeURIComponent(emailFrom.value)
        })
          .then(response => {
            if (response.status === 200) {
              return response.json();
            } else {
              throw new Error("Not 200 response")
            }
          })
          .then(myJson => {
            if (myJson.success) {
              const successTemplate = document.getElementById('form-success')
              const successNode = document.importNode(
                successTemplate.content,
                true
              )
              emptyDialog()
              document.querySelector('.Dialog__Content').appendChild(successNode)
            } else {
              throw new Error("Failure")
            }
          })
          .catch(function (err) {
            const errorTemplate = document.getElementById('form-error')
            const errorNode = document.importNode(errorTemplate.content, true)
            emptyDialog()
            document.querySelector('.Dialog__Content').appendChild(errorNode)
          })
      })
    },
    false
  )
})()

class Toolbar {
  constructor (component) {
    settings.debug && console.log('Toolbar')

    this.component = component

    rovingTabindex(this.component, 'ArrowRight', 'ArrowLeft', '.Button')

    this.component.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.handleSubmit(event.currentTarget)
      })
    })
  }

  handleSubmit(form) {
    settings.debug && console.log('handleSubmit')

    fetch(form.action + '?async=true', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(json => {
      settings.debug && console.log('json', json)
      if (typeof form.dataset.favourite === 'undefined') {
        form.dataset.favourite = ''
      } else {
        delete form.dataset.favourite
      }
    })
  }
}
